import {exists} from 'shared/utils/custom-utils';
import type {Columnable, GridFieldAttribute, GridFieldType} from './types';


export function findExpandableColumns(columnable: Columnable): GridFieldType[] {
    const expandableColumns = [];
    // find only single expandable field per each topfield
    for (const fieldType of columnable.fieldTypes) {
        const expandableColumn = findExpandableColumnRecursive(fieldType);
        if (exists(expandableColumn)) {
            expandableColumns.push(expandableColumn);
        }
    }
    return expandableColumns;
}

function findExpandableColumnRecursive(fieldType: GridFieldType): GridFieldType | undefined {
    if (fieldType.hierarchicalRecordLink.defaultValue) {
        return fieldType;
    }

    for (const type of fieldType.fieldTypes) {
        const res = findExpandableColumnRecursive(type);
        if (exists(res)) {
            return res;
        }
    }
    return undefined;
}

export function resolveGridFieldAttributeValue<T>(flag: GridFieldAttribute<T>, fondId: number): T {
    return flag.fondedValues[fondId] ?? flag.defaultValue;
}